import React, { useEffect, useState } from "react";
import DetailedListItem from "./DetailedListItem";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";


/**
 * 
 * @param {props} data array of object to display
 * @param {props} pdfReader function to show pdf in modal
 *  
 * @returns <ul> 
 */
const DetailedList = ({data, pdfReader}) => {

    const maxItemsToDisplay = 5;
    const [showPagination, setShowPagination] = useState(false);
    const [displayedPage, setDisplayedPage] = useState(1);
    const [filteredData, setFilteredData] = useState([]);


    useEffect(() => {
        if (data.length > maxItemsToDisplay) {
            setShowPagination(true);
            setFilteredData(data.slice(0, maxItemsToDisplay))
        }
        else {
            setFilteredData(data);
            setShowPagination(false);
        }
    }, [data])


    const paginationPrevious = (e) => {
        e.preventDefault();
        setFilteredData(data.slice( (displayedPage -2) * maxItemsToDisplay, maxItemsToDisplay * (displayedPage -1) ));
        setDisplayedPage(prev => (prev -1));
    }


    const paginationNext = (e) => {
        e.preventDefault();
        setFilteredData(data.slice(displayedPage * maxItemsToDisplay, maxItemsToDisplay * (displayedPage +1) ));
        setDisplayedPage(prev => (prev + 1));
    }
    

    return (
        <>
            <ul className="detailed-list">
                {data && data.length > 0?
                    filteredData.map(item => 
                        <>
                            <DetailedListItem item={item} pdfReader={pdfReader} />
                            {item.x_file_mahnung_name !== undefined && item.x_file_mahnung_name !== "False"? 
                                <DetailedList mahnung item={item} pdfReader={pdfReader} /> : null
                            }
                            {item.x_file_stornorechnung_name !== undefined && item.x_file_stornorechnung_name !== "False"? 
                                <DetailedList storno item={item} pdfReader={pdfReader} /> : null
                            }
                        </>
                    )
                    :
                    <DetailedListItem noItem />
                }
            </ul>
            {showPagination?
                <div className="text-center mt-3">
                    {
                        displayedPage === 1 ?
                            <span style={{color: "#c0c4c2"}}><FaChevronLeft /></span>
                        :
                        <a 
                            href="/back" 
                            onClick={e => paginationPrevious(e)} 
                            className="link-energo"
                        >
                            <FaChevronLeft />
                        </a> 
                    }
                    &nbsp;
                    {displayedPage} von {data.length / maxItemsToDisplay} &nbsp;
                    {
                        displayedPage === data.length / maxItemsToDisplay ?
                            <span style={{color: "#c0c4c2"}}><FaChevronRight /></span>
                        :
                        <a href="/next" onClick={e => paginationNext(e)} className="link-energo"><FaChevronRight /></a>
                    }
                </div>
            :null}
        </>
    )
}
export default DetailedList;